import * as SearchActions from '../../../../state/search/search.action';

import template from './b-equipment-update.html';

class BulkEquipmentUpdateController {
  constructor(
    $ngRedux,
    $timeout,
    EquipmentService,
    gettextCatalog,
    equipmentUpdateService,
    keyboardKeysService,
  ) {
    'ngInject';

    this.EquipmentService = EquipmentService;
    this.gettextCatalog = gettextCatalog;
    this.store = $ngRedux;
    this.equipmentUpdateService = equipmentUpdateService;
    this.$timeout = $timeout;
    this.keyboardKeysService = keyboardKeysService;

    this.mapStateToThis = this.mapStateToThis.bind(this);

    this.selectedCols = {
      make: {},
      model: {},
    };
    this.changesState = {};
    this.lastChanges = [];
  }

  $onInit() {
    this.getAttributes();
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
    this.keyboardKeysService.set({
      onCtrlS: this.update.bind(this),
      onCtrlZ: this.undoLastChange.bind(this),
    });
  }

  getAttributes() {
    this.loading = true;
    this.equipmentUpdateService
      .getAttributes()
      .then(({ allAttrs, attrsWithoutReadonly, keyedAttrs }) => {
        const dataTypes = ['text', 'integer', 'decimal', 'hyperlink'];
        this.attributesList = attrsWithoutReadonly.filter((a) =>
          dataTypes.includes(a.dataType.toLowerCase()),
        );
        this.attributesMap = keyedAttrs;
      })
      .catch((error) => {})
      .finally((_) => {
        this.loading = false;
      });
  }

  mapStateToThis(state) {
    const { assets } = state;
    const { list = [] } = assets;
    const selectedAsset = list.filter((asset) => asset.selected);

    return {
      assets: this.equipmentUpdateService.getEditAssetsAttrsModel(selectedAsset),
    };
  }

  $onDestroy() {
    this.unsubscribe();
    this.keyboardKeysService.unSet();
  }

  refreshDetails() {
    this.refresh();
  }

  ///////////
  applyNewValue(key, value) {
    if (!key) return;
    if (value === undefined || value === '' || value === null) return;
    const normalizeKey = key.toLowerCase();
    this.assets.forEach((asset) => {
      asset.attrs[normalizeKey] = { ...asset.attrs[normalizeKey], key, value };
    });
    this.addLastChange(key, '0000');
    this.addToDataLayer(['bulkAssetsUpdate-applyToAll', { key, value }]);
  }

  update() {
    if (this.sending || this.tableErrors > 0) return;
    const changeSet = [];
    this.assets.forEach((asset) => {
      if (JSON.stringify(asset.attrs) !== asset.originalAttrs) {
        const change = {
          id: asset.id,
          op: 'overwrite',
          values: Object.values(asset.attrs).reduce((acc, a) => {
            if (a.value !== '' || a.value !== undefined || a.value !== null) {
              acc[a.key] = a.value;
            }
            return acc;
          }, {}),
        };
        changeSet.push(change);
      }
    });
    if (changeSet.length) {
      this.addToDataLayer(['bulkAssetsUpdate-save', { total: changeSet.length }]);
      this.sending = true;
      this.equipmentUpdateService
        .updateAssetsAttrs(changeSet)
        .then((_) => {
          this.refresh();
          this.changesState = {};
          this.lastChanges = [];
          this.showSuccess = true;
          this.timeMessage();
        })
        .catch((er) => {
          this.showError = true;
          this.timeMessage();
        })
        .finally((_) => {
          this.sending = false;
        });
    }
  }

  addLastChange(key, assetId) {
    const changeKey = `${assetId}&&${key.toLowerCase()}`;
    const [last] = this.lastChanges || [];
    if (last !== changeKey) this.lastChanges.unshift(changeKey);
  }

  undoLastChange() {
    const lastChange = this.lastChanges.shift();
    if (lastChange) {
      const [id, key] = lastChange.split('&&');
      this.assets.forEach((a) => {
        if (a.id === id || id === '0000') {
          if (key in a.attrs) a.attrs[key].value = a.attrs[key].originalVal;
        }
      });

      this.addToDataLayer(['bulkAssetUpdate-undo', { key, id: assetId }]);
    }
  }

  updateAttr(key, value, invalid, asset) {
    const normalizeKey = key.toLowerCase();
    const changeKey = `${asset.id}&&${normalizeKey}`;
    this.changesState[changeKey] = { invalid, value: value };

    if (invalid) {
      return;
    }

    if (value === '' || value === undefined || value === null) {
      delete asset.attrs[normalizeKey].value;
    } else {
      asset.attrs[normalizeKey] = { ...(asset.attrs[normalizeKey] || {}), key, value };
    }

    this.addLastChange(normalizeKey, asset.id);
  }

  onColDeselected(key) {
    this.addToDataLayer(['bulkAssetUpdateAttrDeselected', { key }]);
    // remove from change state
    if (this.changesState) {
      const keyToRemove = Object.keys(this.changesState).filter((k) =>
        k.endsWith(`&&${key.toLowerCase()}`),
      );
      keyToRemove.forEach((k) => {
        delete this.changesState[k];
      });
    }
  }

  get tableErrors() {
    return Object.values(this.changesState || {}).filter((e) => e.invalid).length;
  }

  timeMessage() {
    this.$timeout(() => {
      this.showSuccess = this.showError = false;
    }, 4000);
  }

  removeFromAll(key) {
    let change = false;
    this.assets.forEach((a) => {
      if (key in a.attrs) {
        delete a.attrs[key].value;
        change = true;
      }
    });

    if (change) this.addLastChange(key, '0000');
  }

  addToDataLayer(gtmData) {
    const [event, data] = gtmData || [];
    window.dataLayer.push({
      event,
      data,
    });
  }
}

export default {
  template,
  controller: BulkEquipmentUpdateController,
  controllerAs: 'bvm',
  bindings: {},
};
